export class GoogleWorkspaceGroupMessageTarget {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "GoogleWorkspaceGroupMessageTargetType",
            "format": ""
        },
        {
            "name": "mailboxTarget",
            "baseName": "mailboxTarget",
            "type": "GoogleWorkspaceGroupMessageMailboxTarget",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceGroupMessageTarget.attributeTypeMap;
    }
    constructor() {
    }
}
